import state from './moduleMenuItemManagementState.js'
import mutations from './moduleMenuItemManagementMutations.js'
import actions from './moduleMenuItemManagementActions.js'
import getters from './moduleMenuItemManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

